import { CernerRole } from '@lmc/ts-common'
import { reportsConstants } from 'locale/team'
import EditProfileCard from '../../../../components/forms/screens/TeamMemberEditFormV2/EditProfileCard'
import ProfileFieldRow, { ProfileFieldGrid } from './ProfileFieldRow'

const CERNER_LABELS: Record<string, string> = {
  [CernerRole.NoAccess]: 'No Access',
  [CernerRole.SeniorCarer]: 'Senior Carer Access',
  [CernerRole.Admin]: 'Admin Access',
  [CernerRole.RegisteredManager]: 'Registered Manager Access'
}

type Props = {
  profile: Record<string, any>
  gpConnectEnabled: boolean
  cernerEnabled: boolean
  isProfileGroupUser: boolean
  t: (k: string) => string
}

const ClinicalSystemsAccessViewCard = ({
  profile,
  gpConnectEnabled,
  cernerEnabled,
  isProfileGroupUser,
  t
}: Props) => {
  if (!gpConnectEnabled && !cernerEnabled) {
    return null
  }
  if (isProfileGroupUser) {
    return null
  }
  return (
    <EditProfileCard
      title={t(reportsConstants.PROFILE_VIEW_CARD_CLINICAL)}
      testId="profile-view-clinical"
      showTitleDivider
      fullWidth
    >
      <ProfileFieldGrid>
        {gpConnectEnabled && (
          <ProfileFieldRow
            label={t(reportsConstants.PROFILE_VIEW_GP_CONNECT)}
            value={profile.gpConnectPermission ? 'Clinical' : 'Non-clinical'}
          />
        )}
        {cernerEnabled && (
          <ProfileFieldRow
            label={t(reportsConstants.PROFILE_VIEW_LCR)}
            value={
              CERNER_LABELS[profile.cernerRole] ||
              CERNER_LABELS[CernerRole.NoAccess]
            }
          />
        )}
      </ProfileFieldGrid>
    </EditProfileCard>
  )
}

export default ClinicalSystemsAccessViewCard
